export default function PHP_settype() {
  return (
    <div>
      <h1>PHP_settype</h1>
    </div>
  );
}
